import { useRef } from "react";
import PropTypes from "prop-types";

import { t } from "../../services";

import FlexContainers from "../Containers/FlexContainers";
import Input from "../Input/Input";
import { FirmwareInputVersionWrapper, FirmwareVersionInputContainer } from "./styled";

const FirmwareVersionInput = ({
  firmwareInputConfig,
  values,
  setValues,
  disabled,
  hasError,
  isSmall
}) => {
  const versionInputsRef = useRef(new Array(firmwareInputConfig.length).fill(null));

  const setVersion = (versionType, versionValue) => {
    const newVersionValues = {
      ...values,
      [versionType]: !versionValue ? null : Number(versionValue)
    };

    setValues(newVersionValues);
  };

  const onVersionChange = (versionType, versionValue, minValue, maxValue, currInputIndex) => {
    if (versionValue > maxValue) {
      setVersion(versionType, maxValue);

      const refIndex =
        currInputIndex === versionInputsRef.current.length - 1
          ? currInputIndex
          : currInputIndex + 1;
      versionInputsRef.current[refIndex]?.focus();
    } else if (versionValue < minValue) {
      setVersion(versionType, minValue);
    } else {
      setVersion(versionType, versionValue);
    }
  };

  const onKeyDown = (event, currInputIndex) => {
    if (event.key === "Enter") {
      const refIndex =
        currInputIndex === versionInputsRef.current.length - 1
          ? currInputIndex
          : currInputIndex + 1;

      versionInputsRef.current[refIndex]?.focus();
    }
  };

  return (
    <FirmwareVersionInputContainer Container={FlexContainers.FlexRow} gap={8}>
      {firmwareInputConfig.map((input, index) => {
        return (
          <FirmwareInputVersionWrapper key={input.id}>
            <Input
              id={input.id}
              type="number"
              value={`${values[input.id]}`}
              title={t(input.title)}
              placeholder="0"
              setValue={(value) => onVersionChange(input.id, value, input.min, input.max, index)}
              min={input?.min}
              max={input?.max}
              innerRef={(element) => (versionInputsRef.current[index] = element)}
              onKeyDown={(event) => onKeyDown(event, index)}
              disabled={disabled}
              hasError={hasError}
              isSmall={!!isSmall}
            />
          </FirmwareInputVersionWrapper>
        );
      })}
    </FirmwareVersionInputContainer>
  );
};

FirmwareVersionInput.propTypes = {
  firmwareInputConfig: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      min: PropTypes.number,
      max: PropTypes.number
    })
  ).isRequired,
  values: PropTypes.shape({
    [PropTypes.string]: PropTypes.number
  }).isRequired,
  setValues: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  isSmall: PropTypes.bool
};

export default FirmwareVersionInput;
